/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vivid_Helpful_Weasel_ResideInputs */

const fr_vivid_helpful_weasel_reside = /** @type {(inputs: Vivid_Helpful_Weasel_ResideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date anniversaire`)
};

/**

* @param {Vivid_Helpful_Weasel_ResideInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const vivid_helpful_weasel_reside = /** @type {((inputs?: Vivid_Helpful_Weasel_ResideInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_Helpful_Weasel_ResideInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_vivid_helpful_weasel_reside(inputs)
});